import styled from 'styled-components'

export const OneOfBlock = styled.div`
margin-top: 6px;
`

export const Text = styled.span`
font-family: 'Source Code Pro', Courier, sans-serif;
font-size: 0.8rem;
`
